export const RESOURCE_TYPE = 'RESOURCE_TYPE_RECOMMENDATIONS_DISMISSED_JPD';
export const RESOURCE_KEY = 'recommendations-dismissed-jpd-resource-key';

export const PACKAGE_NAME = 'jiraRouterResourcesRecommendationsDismissedJpd';

export const ANALYTICS_ID = 'useResource.fetchRecommendationsDismissedJpd';
